import { integrationNames } from '@ardoq/integrations/integration-sources';
import { KnowledgeBaseLink } from '@ardoq/knowledge-base';
import { UnifiedAuthMethod } from '@ardoq/api-types/integrations';
import { IntegrationInitialState } from 'integrations/common/initialStateTypes';
import { buildInitialTermsState } from 'integrations/common/streams/integrationTermsDictionary/initialState';
import { UnifiedIntegrationParams } from 'integrations/unified/types';

export const initialState: IntegrationInitialState & UnifiedIntegrationParams =
  {
    activeIntegration: {
      integrationId: 'celonis-exporter',
      integrationMappingParams: {
        mapColumnsBy: 'sourceFieldName',
        mapTablesBy: 'id',
      },
    },
    termsDictionary: buildInitialTermsState({
      name: integrationNames['celonis-exporter'],
      integrationOverviewTitle: 'Celonis Process Management Exporter',
      rightSidebarHeader:
        'Having trouble with the Celonis Process Management Exporter?',
      rightSideBarFAQ: [
        {
          link: KnowledgeBaseLink.CELONIS_PROCESS_MANAGEMENT_EXPORTER,
          text: 'How to export Ardoq applications to Celonis Process Management',
        },
      ],
      connectYourAccountTitle:
        'Connect your Celonis account to Ardoq to get started.',
      connectYourAccountBtn: 'Connect to Celonis',
      overviewPrimaryButton: 'Create new export',
      progressTitle: 'Exporting data to Celonis',
    }),
    authMethodFields: {
      token: {
        label: 'Token',
        fieldDefinitions: [
          {
            keyPath: ['baseUrl'],
            label: 'Symbio base URL',
            type: 'url',
            urlProtocol: 'https://',
            standardDomain: '.symbioweb.com',
            required: true,
          },
          {
            keyPath: ['token'],
            label: 'Symbio API token',
            type: 'text',
            required: true,
          },
          {
            keyPath: ['providerParams', 'collection'],
            label: 'Collection',
            type: 'text',
            required: true,
          },
          {
            keyPath: ['providerParams', 'storage'],
            label: 'Storage',
            type: 'text',
            required: true,
          },
          {
            keyPath: ['providerParams', 'preferredDataCulture'],
            label: 'Preferred language',
            type: 'text',
            required: true,
          },
        ],
      },
    },
    defaultAuthMethod: UnifiedAuthMethod.TOKEN,
  };
